__turbopack_context__.v({
  "body": "styles-module__iqgEAW__body",
  "card": "styles-module__iqgEAW__card",
  "host": "styles-module__iqgEAW__host",
  "pay": "styles-module__iqgEAW__pay",
  "title": "styles-module__iqgEAW__title",
  "who": "styles-module__iqgEAW__who",
});
